import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {DangerButton} from 'Components/Button';
import CreateCmsElementRecord from 'Components/Utilities/CreateCmsElementRecord';

import {translation} from 'Services/TranslationHelpers';

export default class CreateCmsElementRecordModal extends React.Component {
    /**
     * @var state
     */
    state = {
        title: null,
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {onClose, showElementsDropdown, element_id, element_record_id, clone} = this.props;
        const {title} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={onClose}>
                    <span className="capitalize">
                        {title}
                    </span>
                </ModalHeader>

                <ModalBody>
                    <CreateCmsElementRecord
                        showElementsDropdown={showElementsDropdown}
                        element_id={element_id}
                        element_record_id={element_record_id}
                        setTitleCallback={(v) => this.setState({title: v})}
                        clone={clone}
                    />
                </ModalBody>

                <ModalFooter alignment="center">
                    <DangerButton text={translation('misc', 'close')} onClick={onClose} />
                </ModalFooter>
            </Modal>
        )
    }
}